function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Text, Box } from "sprout-ui-primitives";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { Link } from "react-router-dom";
const StyledBox = styled(Box)`
  display: inline-block;
  vertical-align: top;
`;
const PostLabel = (props)=>{
    const { text , style , to  } = props;
    const as = _objectSpread({}, to && {
        as: Link,
        to
    });
    return /*#__PURE__*/ _jsx(StyledBox, _objectSpread({}, as, {
        minWidth: "20px",
        height: "20px",
        my: "2px",
        mr: "6px",
        borderRadius: "20px",
        px: "6px",
        bg: colorMap[style],
        title: text || undefined,
        children: text && /*#__PURE__*/ _jsx(Text, {
            as: "span",
            color: "white.100",
            lineHeight: "20px",
            fontWeight: "bold",
            fontSize: 0,
            children: text
        })
    }));
};
export default PostLabel;
